import { Injectable } from '@angular/core';
import { jwtDecode } from 'jwt-decode';

const TOKEN_KEY = 'auth_token';

@Injectable({ providedIn: 'root' })
export class TokenStorageService {
  setToken(token: string) {
    try { localStorage.setItem(TOKEN_KEY, token); } catch {}
  }
  getToken(): string | null {
    try { return localStorage.getItem(TOKEN_KEY); } catch { return null; }
  }
  getUser(): any {
    try {
      const token = this.getToken();
      if (token) {
        return jwtDecode(token);
      }
      return null;
    } catch (err) {
      console.error('Erro ao decodificar token:', err);
      return null;
    }
  }
  clear() {
    try { localStorage.removeItem(TOKEN_KEY); } catch {}
  }
}
